import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_ACTIONS_MENU_GROUP_IDS = ['edit_in_bulk', 'organize_in_bulk', 'ask_and_explore'] as const;

export type WorkspaceAgentActionsMenuGroupId = (typeof WORKSPACE_AGENT_ACTIONS_MENU_GROUP_IDS)[number];

const META: Meta = {
  description: 'The user opens a group of tasks in the composer Actions menu',
  name: 'agent_actions_menu_group_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description: 'The task group, named after its menu label: edit_in_bulk, organize_in_bulk, or ask_and_explore',
      name: 'group_id',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_ACTIONS_MENU_GROUP_IDS],
    },
  ],
};

export default META;
